<template>
    <div class="video-page">
        <div class="video-page__content">
            <h1 class="video-page__title">
                Video in review
            </h1>
            <p>
                This video is currently being reviewed by other peers.
            </p>
            <div class="video-page__buttons">
                <BaseButton
                    v-if="!loggedIn"
                    class="video-page__video-access"
                    icon-left="play"
                    tabindex="-1"
                    @click="modalStore.toggleModal(MODAL_LOGIN);"
                >
                    Create a free account
                </BaseButton>
                <BaseButton
                    v-if="!loggedIn"
                    class="base-button--content-only base-button--outline"
                    icon-left="lock"
                    tabindex="-1"
                    aria-hidden="true"
                    @click="modalStore.toggleModal(MODAL_LOGIN);"
                >
                    Login
                </BaseButton>
                <BaseButton
                    v-if="loggedIn"
                    :element="defineNuxtLink({})"
                    to="/"
                    class="video-page__video-back"
                    icon-left="arrow-left"
                    tabindex="-1"
                    aria-hidden="true"
                >
                    Return to videos
                </BaseButton>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useModalStore, MODAL_LOGIN } from '~/store/modal';

const modalStore = useModalStore();
const { asset } = useBaseUrl();

defineProps({
    loggedIn: {
        type: Boolean,
        default: false
    }
});

useSeoMeta({
    title: 'MedPeers | Video In-review',
    description: 'Your feedback makes a real difference. We appreciate your time and expertise in helping us ensure the quality and integrity of the content.',
    ogImage: asset('/images/og/default.png')
});
</script>

<style lang="less" src="./VideoPage.less" />

<style lang="less" scoped>
.video-page__content {
    max-width: 100%;
    width: 37em;
    padding: 2em 1em;

    @media @q-lg-min {
        margin: 0 auto;
    }
}

.video-page__title {
    .typography-h1();
    max-width: var(--grid-maxWidth-contentMd);


    @media @q-md-min {
        .typography-h2-xs();
    }

    @media @q-lg-min {
        .typography-h2-md();
    }
}

.video-page__buttons {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
    margin-top: var(--spacing-lg);
}
</style>
